<template>
    <div id="texts">

      <div>
        <h3 v-text="item.artist.name"></h3>
        <h4 v-text="item.name"></h4>
      </div>
        <div class="left_side">
            <div class="share_line">
                <a v-for="soci in item.artist.soci_list" :key="soci.type" :title="soci.name" target="_blank" :href="soci.value"><i :class="soci.icon"></i></a>
                <!-- <a  title="שיתוף" @click="$bus.$emit('share_url', 'Artist/' + item.artist.id)"><i class="fas fa-share"></i></a> -->
            </div>
            <span class="date" v-text="item.online_date_format"></span>

        </div>
    </div>
</template>

<script>

export default {
  props: ["item"],
  data(){
    console.log('lol', this.item);
    return {
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#texts { border-bottom: 1px solid rgba(255,255,255,0.3); margin-bottom: 25px; display: flex; justify-content: space-between;
  @media (min-width: 600px) {  }
  // @media (max-width: 600px) { flex-direction: column; }

    h3 { font-size: 30px; margin-bottom: 10px;}
    h4 { font-size: 20px; font-weight: normal; margin-bottom: 10px;}
    .date { display: block; }

    .left_side{display: flex;flex-direction: column;justify-content: space-around;align-items: flex-end;
      @media (max-width: 600px) {}
      @media (min-width: 600px) {}
    }

    .soci{ width: 38vw;height: 50px;border-bottom: 2px solid #ccc;margin-bottom: 30px;border: none;float:left}
      .share_line {display: flex;gap: 5px;flex-wrap:wrap;justify-content: flex-end;
          @media (max-width: 600px) {}
          @media (min-width: 600px) {}
          a { color: #fff;}
      }
    
}
</style>